var map = {
	"./blog-bg.jpg": "w+js",
	"./favicon.ico": "++yH",
	"./header-background.jpg": "TnAe",
	"./loader.gif": "lc1G",
	"./overlay-bg.png": "UeWx",
	"./portfolio/joaoccm.jpg": "sHJA",
	"./portfolio/workpad.jpg": "d+AS",
	"./portfolio/wvat.jpg": "vzaU",
	"./profilepic.jpg": "om1F"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dYTa";